import React, { useEffect, useState } from 'react'
import { fetchJobDetails } from '../../services/auth.service';
import { useDispatch, useSelector } from 'react-redux';
import { jobId, setLoader } from '../../slice/commonSlice';
import Header from '../../components/header/Header';
import PageHeading from '../../components/pageHeading/PageHeading';
import Footer from '../../components/footer/Footer';
import { getFullName } from '../../utils/common';
import JobDetailCustomer from './JobDetailCustomer';
import CompletedJobDetails from '../completedJobDetails/CompletedJobDetails';

const JobDetails = () => {
  const dispatch = useDispatch();
  const [details, setDetails] = useState({});
  const [jobDetails, setJobDetails] = useState({});
  let id = useSelector(jobId);
  useEffect(()=>{
    if(id){
      fetchJob()
    }
  },[id])
  const fetchJob = async () => {
    let payload = {
      "id": id
    }
    await dispatch(setLoader(true));
    try {
      const response = await fetchJobDetails(payload);
      await dispatch(setLoader(false));
      let [job] = response.data?.jobData
      setJobDetails(job);
      setDetails(response.data);
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  }
  return (
    <>
    {
      jobDetails?.jobType === 'services' ? <JobDetailCustomer details={jobDetails} /> : null
    }
    {
      (jobDetails?.jobType === 'moving' || jobDetails?.jobType === 'delivery') ? <CompletedJobDetails jobDetails={jobDetails} details={details} /> : null
    }
    </>
  )
}

export default JobDetails